__turbopack_context__.v({
  "skeletonCardContent": "n4KcQa_skeletonCardContent",
  "skeletonCardListWrapper": "n4KcQa_skeletonCardListWrapper",
  "skeletonCardWrapper": "n4KcQa_skeletonCardWrapper",
  "skeletonHeader": "n4KcQa_skeletonHeader",
  "skeletonLeftContent": "n4KcQa_skeletonLeftContent",
  "skeletonRightContent": "n4KcQa_skeletonRightContent",
  "spinnerWrapper": "n4KcQa_spinnerWrapper",
});
